import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NormeSrlFieldValidators } from './validators/norme-srl.field-validators';
import { NormeSrlWarningsService } from './warnings/norme-srl.warnings';

@NgModule({
    declarations: [],
    imports: [CommonModule, ReactiveFormsModule],
    providers: [NormeSrlFieldValidators, NormeSrlWarningsService],
})
export class NormeSrlFormModule {}
